import { Heading } from '@slal/ui/typography';
import { styled } from '@slal/ui';

export const StepContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;
    margin-bottom: 8px;
`;

export const Step = styled.div<{ isCompleted: boolean; isActive: boolean }>`
    height: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    background-color: ${({ isActive, isCompleted, theme }) => {
        if (isCompleted) return theme.colors.green__70;
        if (isActive) return theme.colors.blue__secondary__70;
        return theme.colors.neutral__light__40;
    }};
`;

export const StepLabel = styled(Heading)`
    margin-bottom: 16px !important;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral__light__80};
`;
